var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _mask, _path, _path2, _rect7, _rect8, _rect9, _rect10, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCtE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 7,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 31,
    width: 7,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 14,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14,
    width: 3,
    height: 5,
    rx: 1.5,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 33,
    height: 31,
    rx: 2,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 35,
    height: 13,
    rx: 2,
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-outside-1_9933_10340",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 37,
    height: 29,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 7,
    width: 37,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9C10.4477 9 10 9.44772 10 10V27H7C6.44772 27 6 27.4477 6 28V33C6 33.5523 6.44771 34 7 34H11H34H38C38.5523 34 39 33.5523 39 33V28C39 27.4477 38.5523 27 38 27H35V10C35 9.44772 34.5523 9 34 9H11Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9C10.4477 9 10 9.44772 10 10V27H7C6.44772 27 6 27.4477 6 28V33C6 33.5523 6.44771 34 7 34H11H34H38C38.5523 34 39 33.5523 39 33V28C39 27.4477 38.5523 27 38 27H35V10C35 9.44772 34.5523 9 34 9H11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 27V29H12V27H10ZM35 27H33V29H35V27ZM12 10C12 10.5523 11.5523 11 11 11V7C9.34314 7 8 8.34315 8 10H12ZM12 27V10H8V27H12ZM7 29H10V25H7V29ZM8 28C8 28.5523 7.55229 29 7 29V25C5.34315 25 4 26.3431 4 28H8ZM8 33V28H4V33H8ZM7 32C7.55229 32 8 32.4477 8 33H4C4 34.6569 5.34314 36 7 36V32ZM11 32H7V36H11V32ZM34 32H11V36H34V32ZM38 32H34V36H38V32ZM37 33C37 32.4477 37.4477 32 38 32V36C39.6569 36 41 34.6569 41 33H37ZM37 28V33H41V28H37ZM38 29C37.4477 29 37 28.5523 37 28H41C41 26.3431 39.6569 25 38 25V29ZM35 29H38V25H35V29ZM33 10V27H37V10H33ZM34 11C33.4477 11 33 10.5523 33 10H37C37 8.34315 35.6569 7 34 7V11ZM11 11H34V7H11V11Z",
    fill: "#DDAF33",
    mask: "url(#path-7-outside-1_9933_10340)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 19,
    height: 12,
    rx: 2,
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3496,
    y: 19,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(49.8399 21.3496 19)",
    fill: "#D49B00"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27.3496,
    y: 19,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(49.8399 27.3496 19)",
    fill: "#D49B00"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18.8203,
    y: 31.0234,
    width: 2,
    height: 7,
    rx: 1,
    transform: "rotate(-90 18.8203 31.0234)",
    fill: "#D49B00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 30,
    r: 2,
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 30,
    r: 2,
    stroke: "#DDAF33",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCtE);
export default __webpack_public_path__ + "static/media/icon-ct-e.f18c57f8d79053e95ec3301dd09097b5.svg";
export { ForwardRef as ReactComponent };